export default "__VITE_ASSET__bf5e0e43__"